import { PropsWithChildren, useRef, useState } from 'react';

import { Button, Popover } from '@rrexpress/core';

export type DropdownButtonItem = {
  label: string,
  onClick: () => void,
  disabled?: boolean,
};

export type DropdownButtonProps = BBButtonProps & PropsWithChildren<{
  items: DropdownButtonItem[],
  buttonWrapperClassName?: string,
}>;

export function DropdownButton(props: DropdownButtonProps) {
  const {
    children,
    items,
    buttonWrapperClassName,
    ...restProps
  } = props;
  const anchorEl = useRef<HTMLDivElement | null>();

  const [show, setShow] = useState<boolean>(false);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleCloseWhileClickItem = (click: () => void) => () => {
    handleClose();
    document.body.style.overflow = '';
    Promise.resolve().then(() => click());
  };

  return (
    <div className="relative">
      <div
        ref={(ref) => {
          anchorEl.current = ref;
        }}
        className={buttonWrapperClassName}
      >
        <Button {...restProps} onClick={handleOpen}>{children}</Button>
      </div>
      <Popover
        show={show}
        anchorEl={anchorEl.current || document.body}
        onClose={handleClose}
      >
        <div className="flex flex-col items-start">
          {items.map((item, i) => (
            <Button
              key={i}
              variant="text"
              onClick={handleCloseWhileClickItem(item.onClick)}
              className="block whitespace-nowrap"
              disabled={item?.disabled}
            >
              <span className="font-normal text-black">{item.label}</span>
            </Button>
          ))}
        </div>
      </Popover>
    </div>
  );
}
